<template>
    <nuxt-layout name="main-big" :dark="true" :favorite="true">
        <!-- * 基因搜索窗口 -->
        <search-gene-modal ref="modal" trigger="none" @change="methods.open" />
        <!-- * 模型介绍 -->
        <ui-modal ref="info" height="auto" spacing="32px 56px 40px">
            <div class="text-emphas text-[30px] leading-[46px] font-bold">{{ $t("ModelIntroduction") }}</div>
            <div class="mt-[16px]">
                <p>{{ $t("SequenceViewerIntroduction") }}</p>
            </div>
        </ui-modal>

        <div :class="css.container" class="container">
            <!-- * 头部 -->
            <div :class="css.header" class="color-1 font-bold">
                <h1 :class="css.name" class="font-variable">{{ $t("SequenceViewer") }}</h1>
                <h2 :class="css.descript" class="font-variable">{{ $t("SequenceViewerVice") }}</h2>
            </div>

            <ToolSearch
                size="large"
                :class="css.input"
                ref="search"
                v-model="keyword"
                :placeholder="$t('Placeholder.SearchGeneOrID', 2)"
                @search="modal?.open(keyword)" />

            <div class="flex items-center justify-center mt-[80px] max-xl:mt-[64px]">
                <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="info?.openModal()">
                    {{ $t("ModelIntroduction") }}
                </h2>
                <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.next">
                    {{ $t("VideoTutorial") }}
                </h2>
                <div class="w-[1px] h-[12px] mx-[16px] bg-emphas"></div>
                <h2 class="font-normal transition duration-200 cursor-pointer underline underline-offset-2 hover:text-main" @click="methods.image">
                    {{ $t("TextTutorial") }}
                </h2>
            </div>
        </div>
    </nuxt-layout>
</template>

<script lang="ts" setup>
//* 组件库
import { UiModal } from "various-ui";
//* 公共组件
import { SearchGeneModal } from "@/components/windows";
import { ToolSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { keyword } = refs;
const { info, modal } = nodes;
</script>
